/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit

import com.garmin.fit.types.*
import kotlin.time.Instant

/**
 * The FIT `exd_screen_configuration` message.
 *
 * A thin typed view over [Mesg]: the accessors below read and write the same
 * numbered fields the untyped API exposes, so nothing is hidden by using them.
 */
public open class ExdScreenConfigurationMesg : Mesg {
    public constructor() : super("ExdScreenConfiguration", Profile.MesgNum.EXD_SCREEN_CONFIGURATION)

    public constructor(mesg: Mesg) : super(mesg)

    internal constructor(mesg: Mesg, adopt: Boolean) : super(mesg, adopt)

    /** screen_index. */
    public var screenIndex: UByte?
        get() = getFieldValue(SCREEN_INDEX_FIELD_NUM) as? UByte
        set(value) = setFieldValue(SCREEN_INDEX_FIELD_NUM, value)

    /** field_count. number of fields in screen */
    public var fieldCount: UByte?
        get() = getFieldValue(FIELD_COUNT_FIELD_NUM) as? UByte
        set(value) = setFieldValue(FIELD_COUNT_FIELD_NUM, value)

    /** layout. */
    public var layout: ExdLayout?
        get() = (getFieldValue(LAYOUT_FIELD_NUM) as? UByte)?.let { ExdLayout.fromValue(it) }
        set(value) = setFieldValue(LAYOUT_FIELD_NUM, value?.value)

    /** screen_enabled. */
    public var screenEnabled: Boolean?
        get() = (getFieldValue(SCREEN_ENABLED_FIELD_NUM) as? UByte)?.let { it.toInt() != 0 }
        set(value) = setFieldValue(SCREEN_ENABLED_FIELD_NUM, value?.let { if (it) 1 else 0 })

    public companion object {
        public const val SCREEN_INDEX_FIELD_NUM: UByte = 0u
        public const val FIELD_COUNT_FIELD_NUM: UByte = 1u
        public const val LAYOUT_FIELD_NUM: UByte = 2u
        public const val SCREEN_ENABLED_FIELD_NUM: UByte = 3u

        /**
         * The profile definition of every field of this message, with no values.
         *
         * Built once when this class is first touched, and handed out only as
         * copies, so the decoder pays for a message type it never meets nothing.
         */
        internal val PROTOTYPE_FIELDS: Map<Int, Field> = buildPrototypeFields()

        private fun buildPrototypeFields(): Map<Int, Field> {
            val fields = LinkedHashMap<Int, Field>()
            fields[0] = Field("ScreenIndex", 0u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[1] = Field("FieldCount", 1u, BaseType.UINT8, 1.0, 0.0, "", false)
            fields[2] = Field("Layout", 2u, BaseType.ENUM, 1.0, 0.0, "", false)
            fields[3] = Field("ScreenEnabled", 3u, BaseType.ENUM, 1.0, 0.0, "", false)
            return fields
        }
    }
}
